import React from 'react';
import DropdownElement from '../DropdownElement';
const VariantInStockDropdownElement = ({ variant, onClickChangeItemVariant, labelFewPiecesLeft, isDropDownItemsCenterAligned, }) => {
    if (!variant.stock.stockLevel)
        return null;
    return (React.createElement(DropdownElement, { variantCode: variant.code, isVariantSelected: variant.selected, value: variant.size.name, valueInfo: variant.fewPieceLeft ? labelFewPiecesLeft : undefined, isDropDownItemsCenterAligned: isDropDownItemsCenterAligned, data: variant.code, onClickChangeItemVariant: () => {
            onClickChangeItemVariant(variant.code);
        } }));
};
export default VariantInStockDropdownElement;
//# sourceMappingURL=VariantInStockDropdownElement.js.map